import { useState, useEffect } from "react";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img
            src="https://public.readdy.ai/ai/img_res/7870f51d-e5a2-48e2-b603-e53d2018e600.png"
            alt="MONTANA OOD Logo"
            className="h-10 w-auto object-contain"
          />
          <span
            className={`text-xl font-semibold tracking-wide transition-colors duration-300 ${
              scrolled ? "text-gray-900" : "text-white"
            }`}
          >
            MONTANA OOD
          </span>
        </div>

        <nav className="hidden md:flex items-center gap-8">
          {["about", "products", "contact"].map((section) => (
            <button
              key={section}
              onClick={() => scrollTo(section)}
              className={`text-sm font-medium capitalize tracking-wide transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                scrolled
                  ? "text-gray-600 hover:text-gray-900"
                  : "text-white/80 hover:text-white"
              }`}
            >
              {section.charAt(0).toUpperCase() + section.slice(1)}
            </button>
          ))}
        </nav>

        {/* Mobile menu icon */}
        <button
          className={`md:hidden w-8 h-8 flex flex-col items-center justify-center gap-1.5 cursor-pointer`}
          aria-label="Menu"
        >
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              className={`block w-5 h-0.5 transition-colors duration-300 ${
                scrolled ? "bg-gray-800" : "bg-white"
              }`}
            />
          ))}
        </button>
      </div>
    </header>
  );
}
